import { t } from '@lingui/macro';
import Trash from '@decisiv/iconix/lib/components/Trash';
import Button from '@decisiv/ui-components/lib/components/Button';
import Checkbox from '@decisiv/ui-components/lib/components/Checkbox';
import Flex from '@decisiv/ui-components/lib/components/Flex';
import { P } from '@decisiv/ui-components/lib/components/Typography';

import { type ContactDepot } from '../DepotSelector';
import { DepotCardWrapper } from './styles';

interface DepotCardProps {
  depot: ContactDepot;
  onRemove: (depotId: string) => void;
  isPrimary?: boolean;
  onPrimaryChange: (depotId: string, checked: boolean) => void;
}

const DepotCard = ({
  depot,
  onRemove,
  isPrimary,
  onPrimaryChange,
}: DepotCardProps) => {
  const locationParts = [depot.platformAccountName, depot.city, depot.state]
    .filter(Boolean)
    .join(' \u00B7 ');

  return (
    <DepotCardWrapper>
      <Flex
        flex={1}
        flexDirection="column"
        style={{ gap: '2px', overflow: 'hidden' }}
      >
        <P>{depot.name}</P>
        {locationParts && (
          <P size="small" shade={1}>
            {locationParts}
          </P>
        )}
        <Checkbox
          key={`${depot.id}-primary-${isPrimary}`}
          size="small"
          checked={isPrimary}
          label={t`Primary Contact`}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onPrimaryChange(depot.id, e.target.checked)
          }
        />
      </Flex>
      {!depot?.isFixed && (
        <Button
          size="small"
          kind="secondary"
          icon={Trash}
          aria-label={`Remove depot ${depot.name}`}
          onClick={() => onRemove(depot.id)}
        />
      )}
    </DepotCardWrapper>
  );
};

export default DepotCard;
